import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type {
  CriteriaScore,
  CriteriaScoreStatus,
  CriteriaScoreUpsert,
  PagedResponse,
} from '../types'

const BASE = '/management/activity-criteria-scores'

/** Silinmemiş kayıtların (sıralı) listesi. Lookup ölçeği küçük → tümünü tek sayfada çekeriz (size=200). */
export async function getCriteriaScores(): Promise<PagedResponse<CriteriaScore>> {
  const { data } = await apiClient.get<PagedResponse<CriteriaScore>>(BASE, {
    params: { page: 0, size: 200 },
  })
  return data
}

/** Yeni kayıt oluştur (201 → oluşturulan kayıt). */
export async function createCriteriaScore(body: CriteriaScoreUpsert): Promise<CriteriaScore> {
  const { data } = await apiClient.post<CriteriaScore>(BASE, body)
  return data
}

/** Kaydı güncelle (ad/ağırlık; optimistic lock modDate zorunlu). */
export async function updateCriteriaScore(
  id: number,
  body: CriteriaScoreUpsert,
): Promise<CriteriaScore> {
  const { data } = await apiClient.put<CriteriaScore>(`${BASE}/${id}`, body)
  return data
}

/** Durum değiştir (Aktif/Pasif; yalnız 0↔1). */
export async function changeCriteriaScoreStatus(
  id: number,
  body: CriteriaScoreStatus,
): Promise<CriteriaScore> {
  const { data } = await apiClient.put<CriteriaScore>(`${BASE}/${id}/status`, body)
  return data
}

/** Soft-delete (record_status=2). 204. */
export async function deleteCriteriaScore(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

/**
 * Yeniden sıralama — ekranda görünen tüm (silinmemiş) kayıtların id sırası. Backend bu sırayı 1..N
 * SORT_INDEX olarak yeniden yazar (pairwise takas değil; çift değeri onarır). 204.
 */
export async function reorderCriteriaScores(orderedIds: number[]): Promise<void> {
  await apiClient.put(`${BASE}/reorder`, { orderedIds })
}

/**
 * Değerlendirme kriterleri listesini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportCriteriaScores(): Promise<void> {
  await downloadXlsx(`${BASE}/export`, {}, 'degerlendirme-kriterleri.xlsx')
}
